var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Vue-Good-Table',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"search-options":{
        enabled: true,
        skipDiacritics: true,
    },"style-class":"vgt-table striped"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'links')?_c('div',{staticClass:"flex items-center"},[_c('Table-Links',{attrs:{"row":props.row}})],1):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }